<nav class="navbar navbar-dark bg-primary py-1 ps-1 text-light">
  <div>
    <a class="navbar-brand text-light" tabindex="-1" [routerLink]="['/']">
      {{headerInfo() ? 'S11' : 'SuperElf'}}
    </a>
  </div>

  @let tmplHeaderInfo = headerInfo();
  @if(tmplHeaderInfo) {
    <div>
      <h1 class="h3 text-truncate me-1 d-flex mb-0 pointer" (click)="navigateToPoolHome(tmplHeaderInfo.urlSuffix, tmplHeaderInfo.id)">
        <span class="me-1">{{tmplHeaderInfo.name}}</span>
    
        <small class="d-flex flex-column p-0" style="font-size: 11px;">
          <span>{{getSeasonStart(tmplHeaderInfo.start)}}</span>
          <span>{{getSeasonEnd(tmplHeaderInfo.start)}}</span>
        </small>
    
      </h1>
    </div>
  }

  @if(authService.isLoggedIn()) {
    <button (click)="navigateToProfile()" class="btn text-light border-0 p-0 pt-1" role="button" tabindex="-1" aria-label="account">
      <fa-icon [icon]="faUserCircle" size="3x"></fa-icon>
    </button>
  } @else {
    <button class="btn text-light" role="button" aria-label="inloggen " tabindex="-1" (click)="navigateToLogin()">
      <fa-icon [icon]="faSignInAlt"></fa-icon>
      <span class="ms-1">inloggen</span>
    </button>
  }
  
  

  <!-- <button class="navbar-toggler navbar-toggler-right pointer" type="button" data-toggle="collapse
    " data-target="#navbarResponsive "
    aria-controls="navbarResponsive " aria-label="Toggle navigation " (click)="navbarCollapsed=! navbarCollapsed
    " [attr.aria-expanded]="!navbarCollapsed ">
    <span class="navbar-toggler-icon "></span>
  </button>
  <div class="collapse navbar-collapse " [ngbCollapse]="navbarCollapsed " id="navbarResponsive ">
    <ul class="navbar-nav ">
      <li *ngIf="isLoggedIn() " class="nav-item ">
        <a class="nav-link " [routerLink]="/admin " [routerLinkActive]="active " (click)="navbarCollapsed=! navbarCollapsed ">admin</a>
      </li>
    </ul>

    <ul class="nav navbar-nav ms-auto ">
      <li *ngIf="!isLoggedIn() " class="nav-item ">
        <a class="nav-link" [routerLink]="/user/login " [routerLinkActive]="active " (click)="navbarCollapsed=!navbarCollapsed ">inloggen</a>
      </li>
      <li *ngIf="isLoggedIn() " class="nav-item ">
        <a class="nav-link" [routerLink]="/user/logout " [routerLinkActive]="active " (click)="navbarCollapsed=!navbarCollapsed ">uitloggen</a>
      </li>
    </ul>
  </div> -->
</nav>